import { useSelector } from '@betty/toolkit/state';
import { selectFilteredLimitsByType } from '../components/ResponsibleGaming/state';
import { PeriodInputProps } from '../components/ResponsibleGaming/components/PeriodInput/PeriodInput.types';

export const useDefaultLimitValue = ({ type }: PeriodInputProps) => {
  const limits = useSelector(selectFilteredLimitsByType(type));

  if (!limits?.length) {
    return null;
  }
  return limits.map(({ type, period, amount }) => ({ type, period, amount }));
};
